import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./index.css";
import "./shared/styles/variables.css";
const root = ReactDOM.createRoot(document.getElementById("root"));

// Unregister any legacy service workers that might be caching the old index.html
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
